import React, {useEffect, useRef, useState} from "react";
import {Button} from "primereact/button";
import {useTranslate} from "../../../system/useTranslate";

function FreeBoardQuickTaskComposer({
    columnId,
    onCreate,
    onCreated,
}) {
    const translate = useTranslate();
    const titleRef = useRef(null);
    const [active, setActive] = useState(false);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        const openForColumn = (event) => {
            if (String(event.detail?.columnId) === String(columnId)) setActive(true);
        };
        window.addEventListener("free-board:open-quick-task", openForColumn);
        return () => window.removeEventListener("free-board:open-quick-task", openForColumn);
    }, [columnId]);

    const close = () => {
        if (titleRef.current) titleRef.current.value = "";
        setSaving(false);
        setActive(false);
    };

    const save = async () => {
        const normalizedTitle = String(titleRef.current?.value || "").trim();
        if (!normalizedTitle || saving) return;
        setSaving(true);
        try {
            const created = await onCreate(normalizedTitle, columnId);
            if (created) {
                if (titleRef.current) titleRef.current.value = "";
                onCreated?.(created, columnId);
                setActive(false);
            }
        } finally {
            setSaving(false);
        }
    };

    if (!active) {
        return (
            <Button
                type="button"
                text
                severity="secondary"
                icon="pi pi-plus"
                label={translate("free-board.add-task")}
                className="w-full justify-content-start text-xs gap-2"
                onClick={() => setActive(true)}
            />
        );
    }

    return (
        <div className="surface-card p-2 border-round-xl border-1 border-primary shadow-1">
            <textarea
                ref={titleRef}
                autoFocus
                rows={2}
                defaultValue=""
                className="w-full text-xs border-none shadow-none p-1 resize-none shabnam-font"
                placeholder={translate("free-board.task-title-placeholder")}
            />
            <div className="flex align-items-center gap-2 mt-2">
                <Button type="button" label={translate("save")} className="text-xs" loading={saving} disabled={saving} onClick={save}/>
                <Button type="button" text severity="secondary" label={translate("cancel")} className="text-xs" disabled={saving} onClick={close}/>
            </div>
        </div>
    );
}

export default FreeBoardQuickTaskComposer;
